import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const titles: Record<string, string> = {
  "/": "· Homepage",
  "/about": "· About",
  "/now": "· Now",
};

const BASE_TITLE = document.title;

export function TitleUpdater() {
  const location = useLocation();

  useEffect(() => {
    const suffix = titles[location.pathname] ?? "· Home";
    document.title = `${BASE_TITLE} ${suffix}`;
  }, [location]);

  return null;
}
